<script module lang="ts">
  import Layout from '../components/Layout.svelte'
  import { translate } from '../i18n'
  import type { Locale } from '../translations'

  export const layout = (props: { locale: Locale }) => ({
    component: Layout,
    props: { title: translate(props.locale, 'footer.mediaLicense') },
  })
</script>

<script lang="ts">
  import LegalPage from '../components/LegalPage.svelte'
  import OperatorEmail from '../components/OperatorEmail.svelte'
  import { getI18n } from '../i18n'
  import { MEDIA_CREDIT, mediaLicenseDeedUrl } from '../mediaLicense'

  const i18n = getI18n()
</script>

<LegalPage title={i18n.t('footer.mediaLicense')}>
  <p class="media-license-intro">{i18n.t('mediaLicense.intro')}</p>

  <h2 class="media-license-heading">{i18n.t('mediaLicense.credit.heading')}</h2>
  <p>{i18n.t('mediaLicense.credit.text')}</p>
  <p class="media-license-credit"><bdi>{MEDIA_CREDIT}</bdi></p>
  <p>{i18n.t('mediaLicense.credit.link')}</p>

  <h2 class="media-license-heading">{i18n.t('mediaLicense.ai.heading')}</h2>
  <p>{i18n.t('mediaLicense.ai.text', { credit: MEDIA_CREDIT })}</p>

  <h2 class="media-license-heading">{i18n.t('mediaLicense.license.heading')}</h2>
  <p>
    {i18n.t('mediaLicense.license.text')}
    <a href={mediaLicenseDeedUrl(i18n.locale)} rel="license" class="media-license-link">{i18n.t('mediaLicense.license.link')}</a>
  </p>

  <h2 class="media-license-heading">{i18n.t('mediaLicense.scope.heading')}</h2>
  <p>{i18n.t('mediaLicense.scope.text')}</p>

  <p class="media-license-email-label">{i18n.t('mediaLicense.contact')}</p>
  <OperatorEmail />

  <p class="media-license-updated">{i18n.t('mediaLicense.updated')}</p>
</LegalPage>

<style>
  .media-license-intro {
    margin-top: var(--space-9);
  }

  .media-license-heading {
    margin-top: var(--space-10);
  }

  .media-license-credit {
    padding: var(--space-5) var(--space-7);
    border-radius: var(--radius-2);
    background-color: var(--color-gray-95);
    color: var(--color-heading);
    font-weight: var(--font-weight-3);
  }

  .media-license-link {
    color: inherit;
  }

  .media-license-email-label {
    margin-top: var(--space-10);
    margin-bottom: 0;
  }

  .media-license-updated {
    margin-top: var(--space-10);
    font-size: var(--font-size-4);
    color: var(--color-text-muted);
  }
</style>
